import { FunctionComponent, memo } from "react";
import { useFormikContext } from "formik";
import { faUndo } from "@fortawesome/pro-solid-svg-icons/faUndo";
import { Tooltip } from "../../../../tooltip";
import { ActionIcon } from "../../../../action-icon";
import { Icon } from "../../../../icon";

/**
 * Component for a reset button to reset form filters.
 * @returns {JSX.Element} ResetButton component.
 */
const ResetButton: FunctionComponent<{}> = () => {
    const { dirty, resetForm } = useFormikContext();
    return (
        <Tooltip label={"Reset Filters"} openDelay={750}>
            <ActionIcon
                variant="default"
                size="input-sm"
                onClick={() => {
                    resetForm();
                }}
                disabled={!dirty}
                data-testid="filters-reset-button"
                aria-label="reset filters"
                type="submit"
            >
                <Icon icon={faUndo} />
            </ActionIcon>
        </Tooltip>
    );
};

export default memo(ResetButton);
